import ToolsSidebar from "./tools-sidebar";

import "./sidebars.scss";


const Sidebars = {
    Tools : ToolsSidebar
}

export default Sidebars;